import { Drawer } from "@mui/material";

export default function MuiDrawer({children, ...rest}: any) {
    return (
        <Drawer {...rest}>
            {children}
        </Drawer>
    ) 
}